import React, { useEffect, useMemo } from "react";
import { Button } from "@packages/ui";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import { apiURI } from "../../env";
import { shouldSkipIdVerification } from "src/components/Checkin/Verify/CheckOcrLabsOutage";
import * as checkinActions from "src/actions/checkinActions";
import { Link, Typography, List, ListItem } from "@material-ui/core";
import getCountryFromURL from "src/utils/getCountryFromUrl";

const CheckinPrivacy = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const checkin = useSelector((state) => state.checkin);
  const isDemo = useSelector((state) => state.checkin.isDemo);
  const isAdditionalDriver = useSelector((state) => state.checkin.isAdditionalDriver);
  const isHCCWorkflow = useSelector((state) => state.checkin.resType === "HX");
  const navigate = useNavigate();
  // const brand = 'Hertz'
  const brand = getBrandFromUrl();
  const randomNumber = useMemo(() => {
    return Math.random();
  }, [checkin.resNo]);

  let path;

  React.useEffect(() => {
    const shouldSkip = shouldSkipIdVerification(checkin.ocrLabsOutage);
    if (shouldSkip) {
      dispatch(checkinActions.idVerificationSkipped({}));
      // because additional driver only needs to do idverification, so if outage,
      // then no need to view privacy at all, just directly jump to checkin-form
      if (isAdditionalDriver) {
        navigate(
          `/${
            isDemo ? "checkin-demo" : isAdditionalDriver ? "additional-driver-checkin" : "checkin"
          }/checkin-form`,
          { replace: true }
        );
      } else {
        if (isHCCWorkflow) {
          // reach here means this is a primary driver and does not need to do cc validation
          // so if outage, then no need to privacy as well, just also jump to checkin-form
          navigate(
            `/${
              isDemo ? "checkin-demo" : isAdditionalDriver ? "additional-driver-checkin" : "checkin"
            }/checkin-form`,
            { replace: true }
          );
        }
      }
    }
  }, [checkin.ocrLabsOutage]);

  if (brand == "Dollar" && !isDemo) {
    path = isAdditionalDriver
      ? {
          "/additional-driver-checkin/privacy/dollar": {
            url_privacy:
              "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
            url_touchless:
              "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
            next: "/additional-driver-checkin/steps",
          },
        }
      : {
          "/checkin/privacy/dollar": {
            url_privacy:
              "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
            url_touchless:
              "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
            next: "/checkin/steps",
          },
        };
  } else if (brand == "Thrifty" && !isDemo) {
    path = isAdditionalDriver
      ? {
          "/additional-driver-checkin/privacy/thrifty": {
            url_privacy:
              "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
            url_touchless:
              "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
            next: "/additional-driver-checkin/steps",
          },
        }
      : {
          "/checkin/privacy/thrifty": {
            url_privacy:
              "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
            url_touchless:
              "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
            next: "/checkin/steps",
          },
        };
  } else if (brand == "Hertz" && !isDemo) {
    path = isAdditionalDriver
      ? {
          "/additional-driver-checkin/privacy/hertz": {
            url_privacy:
              "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
            url_touchless:
              "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
            next: "/additional-driver-checkin/steps",
          },
        }
      : {
          "/checkin/privacy/hertz": {
            url_privacy:
              "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
            url_touchless:
              "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
            next: "/checkin/steps",
          },
        };
  } else if (brand == "Ace" && !isDemo) {
    path = isAdditionalDriver
      ? {
          "/additional-driver-checkin/privacy/ace": {
            url_privacy:
              "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
            url_touchless:
              "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
            next: "/additional-driver-checkin/steps",
          },
        }
      : {
          "/checkin/privacy/ace": {
            url_privacy:
              "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
            url_touchless:
              "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
            next: "/checkin/steps",
          },
        };
  } else if (brand == "Dollar" && isDemo) {
    path = {
      "/checkin-demo/privacy/dollar": {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/checkin-demo/steps",
      },
    };
  } else if (brand == "Thrifty" && isDemo) {
    path = {
      "/checkin-demo/privacy/thrifty": {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/checkin-demo/steps",
      },
    };
  } else if (brand == "Hertz" && isDemo) {
    path = {
      "/checkin-demo/privacy/hertz": {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/checkin-demo/steps",
      },
    };
  } else if (brand == "Ace" && isDemo) {
    path = {
      "/checkin-demo/privacy/ace": {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/checkin-demo/steps",
      },
    };
  }

  return (
    <React.Fragment>
      <div style={{ textAlign: "center" }}>
        <List
          style={{
            height: "calc(100vh - 190px)",
            overflow: "hidden",
            marginBottom: "15px",
            padding: "20px 15% 0",
          }}
          subheader={
            <Typography
              variant="subtitle1"
              style={{ textAlign: "left", fontWeight: "bold", margin: "40px 0" }}
            >
              By clicking “I Agree” you agree to be bound by, and have read:
            </Typography>
          }
        >
          <ListItem>
            <Link href={path[location.pathname].url_privacy} target="_blank">
              i. Privacy Policy
            </Link>
          </ListItem>
          <ListItem>
            <Link href={path[location.pathname].url_touchless} target="_blank">
              ii. Touchless Privacy Disclosure, Consent and Release
            </Link>
          </ListItem>
        </List>
        <Button
          title={<strong>I Agree</strong>}
          onClick={(e) => navigate(path[location.pathname].next, { replace: true })}
          type="submit"
        />
        <img
          src={`${apiURI}/pixel/${location.pathname.replace(/\//g, "_")}.png?b=${
            checkin.resNo
          }&a=privacy&country=${getCountryFromURL()}&c=${randomNumber}&brand=${brand}&t=${
            isAdditionalDriver ? "additional_driver" : "primary_driver"
          }`}
          style={{ display: "none" }}
        />
      </div>
    </React.Fragment>
  );
};
export default CheckinPrivacy;
